import React from "react";
import styled from "styled-components";

const getButtonSize = (size) => {
  switch (size) {
    case "small":
      return "0.5rem 1rem";
    case "medium":
      return "0.5rem 1rem";
    default:
      return "0.5rem 1rem";
  }
};

const StyledVariant = styled.a`
  border: 1px solid ${({ border }) => border || "#f7d000"};
  cursor: pointer;
  padding: ${({ size }) => getButtonSize(size)};
  text-decoration: none;
  border-radius: 21px;
  font-size: 11.32px;
  font-weight: 400;
  background-color: ${({ background }) => background || "transparent"};
  color: ${({ color }) => (color ? color : "black")};
  filter: 'blur(4px)',
`;

const Variant = ({
  text,
  color,
  background,
  border = "#f7d000",
  size = "medium",
}) => {
  return (
    <StyledVariant
      href="#"
      color={color}
      background={background}
      border={border}
      size={size}
    >
      {text}
    </StyledVariant>
  );
};

export default Variant;
